import script from "./MultipleSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&setup=true&lang=js"

import "./MultipleSelect.vue?vue&type=style&index=0&id=2cb3e6ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb3e6ae"]])

export default __exports__